import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  viewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  GetSmartScheduledMessageCalculationsQuery,
  GetSmartSmsRequestByIdDto,
  GetSmartSmsRequestByIdForDetailDto,
  GetSmartSmsRequestsWithPaginationDto,
  SmartRequestTypes,
  SmartSmsRequestPeriodicPatterns,
  SmsAggregator,
} from 'src/app/core/api/models';
import {
  EnumsService,
  ScheduledMessagesService,
  SmartSmsRecipientsService,
  SmartSmsRequestsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { ThemeColorPipe } from 'src/app/core/utils/theme/theme-color.pipe';
import { DateTimeConfig } from 'src/app/shared/components/date-time-picker/date-time-picker.component';
import { PeriodicDateTimeConfig } from 'src/app/shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { PeriodicTypeConfig } from 'src/app/shared/components/periodic-type/periodic-type.component';
import { SmartSendConfirmationMapComponent } from 'src/app/shared/components/smart-send-confirmation-map/smart-send-confirmation-map.component';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';
import { BaseSendSmsConfig } from '../../sending-system/base/base-send-sms/base-send-sms.component';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import { BaseFormModule } from '../../shared/base/modules/base-form.module';
import { SmartSmsRequestPeriodicPatternsComponent } from '../send-smart-sms-confirm-request/smart-sms-request-periodic-patterns/smart-sms-request-periodic-patterns.component';
import { ViewFiltersComponent } from '../send-smart-sms-confirm-request/view-filters/view-filters.component';
import { SmartSmsOperatorsComponent } from '../smart-sms-operators/smart-sms-operators.component';

@Component({
  selector: 'app-smart-sms-detail',
  templateUrl: './send-smart-sms-detail.html',
  styleUrls: ['./send-smart-sms-detail.scss'],
  imports: [
    BaseFormModule,
    SmartSmsOperatorsComponent,
    SmartSmsRequestPeriodicPatternsComponent,
    ThemeColorPipe,
    SmsBodyModule,
    ViewFiltersComponent,
  ],
})
export class SendSmartSmsDetailPage
  extends BaseFormPageComponent
  implements OnInit, AfterViewInit
{
  //#region properties
  readonly Map = viewChild<SmartSendConfirmationMapComponent>('Map');
  readonly filterViewer = viewChild<ViewFiltersComponent>('filterViewer');

  @Input() detailModel: GetSmartSmsRequestByIdForDetailDto;
  @Input() selectedItem: GetSmartSmsRequestsWithPaginationDto;

  formId: string = 'SendSmartSmsConfirmPageForm';
  model: GetSmartScheduledMessageCalculationsQuery;
  senderNumberId: any = 0;
  baseSendSmsConfig: BaseSendSmsConfig;
  directDateTimeConfig: DateTimeConfig;
  periodicTypeConfig: PeriodicTypeConfig;
  periodicDateTimeConfig: PeriodicDateTimeConfig;

  directSendDateTime: string = '';
  isExistsMCI: boolean = false;
  isExistsIrancell: boolean = false;
  isExistsRightel: boolean = false;
  selectedOperator: SmsAggregator;

  maxSendCount: number;

  get SmsAggregator() {
    return SmsAggregator;
  }

  Model = [];
  appLang: string = 'fa';
  showSidePanel: boolean = true;
  isShowMap: boolean = true;
  selectedDateTimesForPeriodicPattern: string[] = [];
  periodicPattern: SmartSmsRequestPeriodicPatterns =
    SmartSmsRequestPeriodicPatterns.DaysOfWeek;

  //#endregion

  public constructor(
    public dynamicTabService: DynamicTabService,
    public dialogService: DialogService,
    public scheduledMessageService: ScheduledMessagesService,
    public smartSmsRecipientService: SmartSmsRecipientsService,
    public smartRequestService: SmartSmsRequestsService,
    public smartSmsShareMem: SmartSmsShareMemoryService,
    public translate: TranslateService,
    public enumService: EnumsService
  ) {
    super();
    this.dataLoaded = false;
  }

  initModel(): void {
    if (
      this.detailModel.smartRequestType ==
        SmartRequestTypes.WelcomeForAirports ||
      this.detailModel.smartRequestType == SmartRequestTypes.WelcomeForCity ||
      this.detailModel.smartRequestType == SmartRequestTypes.WelcomeForProvince
    )
      this.isShowMap = false;
    const { periodicPatterns, validDateTimesForPeriodicPattern } =
      this.detailModel;
    this.periodicPattern = periodicPatterns;
    this.selectedDateTimesForPeriodicPattern =
      validDateTimesForPeriodicPattern || [];
  }

  initForm(): void {
    this.form = new FormGroup({
      sendDate: new FormControl(''),
      sendTime: new FormControl(''),
      smsBody: new FormControl(''),
      senderNumberId: new FormControl(''),
      title: new FormControl(''),
      socialMediaApplicationName: new FormControl(''),
      socialMediaFileTitle: new FormControl(''),

      sendDateTime: new FormControl('', []),
      periodTypeValue: new FormControl(''),
      startDatetime: new FormControl(''),
      startTime: new FormControl(''),
      endDatetime: new FormControl(''),
      endTime: new FormControl(''),
      startTimeAtDay: new FormControl(''),
      endTimeAtDay: new FormControl(''),
      maxSendCount: new FormControl(''),
      maxDailySendCount: new FormControl(''),
      campaignId: new FormControl(''),
      smartSmsClubTitle: new FormControl(''),
      smartSmsClubOperationTypeTitle: new FormControl(''),
      grayListExpireHour: new FormControl(''),

      sendDelay: new FormGroup({
        sentDelayType: new FormControl(''),
        sentDelayValue: new FormControl(''),
      }),
    });
  }

  configBaseSendSMS() {
    try {
      let isValidStartDate = DateTimeService.isValidUtcDateTime(
        this.detailModel.startDatetime
      );
      let isValidEndDate = DateTimeService.isValidUtcDateTime(
        this.detailModel.endDatetime
      );

      this.baseSendSmsConfig = {
        title: this.pageVocabs + 'title',
        isEdit: this.formPageConfig.isEditMode,
        msgInfoClassList: 'md:tw-w-1/3 tw-mt-2 offset-md-2',
        sendDateTimeClassList: 'md:tw-w-1/3 tw-mt-2',
        isShowReceivers: false,
        isShowFastSend: false,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: !this.formPageConfig?.isEditMode ? true : false,
        isShowPageHeader: false,
        isConvertToIsoString: false,
      };

      this.directDateTimeConfig = {
        dateLabel: this.fields + 'sendDay',
        timeLabel: this.fields + 'sendHour',
        dateFormControl: this.form?.get('sendDate') as FormControl,
        timeFormControl: this.form?.get('sendTime') as FormControl,
        dateTimeValue: this.detailModel.startDatetime,
      };

      this.periodicDateTimeConfig = {
        startDateLabel: 'common.startDate',
        startTimeLabel: 'common.startTime',
        endDateLabel: 'common.endDate',
        endTimeLabel: 'common.endTime',
        startDateFormControl: this.form?.get('startDatetime') as FormControl,
        startTimeFormControl: this.form?.get('startTime') as FormControl,
        endDateFormControl: this.form?.get('endDatetime') as FormControl,
        endTimeFormControl: this.form?.get('endTime') as FormControl,
        isConvertToIsoString: false,
        isEditMode: this.formPageConfig.isEditMode,
        minStartDateType: 'today',
        maxStartDateType: 'unlimited',
        maxEndDateType: 'unlimited',
        responsiveClassName: 'md:tw-w-1/2',
        maxStartTimeTheCurrentTimeIfDateIsToday: false,
        minStartTimeTheCurrentTimeIfDateIsToday: true,
        maxEndTimeTheCurrentTimeIfDateIsToday: false,
        isAdvancedSearch: true,
        isShowStartDateIconValidation: false,
        endDateTimeValue: isValidEndDate ? this.detailModel.endDatetime : '',
        startDateTimeValue: isValidStartDate
          ? this.detailModel.startDatetime
          : '',
      };

      this.periodicTypeConfig = {
        periodTypeLabel: this.fields + 'sentDelayType',
        periodTextLabel: this.fields + 'sentDelayValue',
        periodText: this.detailModel.periodValue,
        periodType: this.detailModel.periodType,
        isTextParser: true,
        isDisableSentDelayType: true,
        periodTypeControl: this.form?.get(
          'sendDelay.sentDelayType'
        ) as FormControl,
        periodTextControl: this.form?.get(
          'sendDelay.sentDelayValue'
        ) as FormControl,
      };

      if (this.formPageConfig.isEditMode) {
        this.baseSendSmsConfig.isEdit = true;
        this.baseSendSmsConfig.justShowDirectDateTimeForEdit = true;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  data: GetSmartSmsRequestByIdDto;
  dataLoaded: boolean = false;
  loadingError: string = '';
  smartRequestId: number;

  /**
   * this method load smartSmsRequest from server and fill the grid,the map and etc
   * then user can change the number of sms he or she want to send
   * the privateNumberId and smsBody and etc most fill by the user
   * @param id smart sms request id
   */
  loadWithRequestId(id: number) {
    if (this.detailModel != null) {
      this.smartSmsShareMem.setScheduledMessageTitle(this.detailModel.title);

      this.dataLoaded = true;
      this.data = this.detailModel;
      const filterViewer = this.filterViewer();
      filterViewer.filters = this.detailModel.filterEnums;

      let obj = JSON.parse(this.detailModel.responseData);
      (Object.keys(obj) as (keyof typeof obj)[]).forEach((key, index) => {
        obj[key] = JSON.parse(obj[key]);
      });
      filterViewer.filterToDisplay = obj;
      filterViewer.createDisplayText();
      this.Model = [];

      let i = 0;
      this.data.recipients.forEach((element) => {
        if (element.operator == SmsAggregator.MCI) this.isExistsMCI = true;
        if (element.operator == SmsAggregator.Irancell)
          this.isExistsIrancell = true;
        if (element.operator == SmsAggregator.Rightel)
          this.isExistsRightel = true;
        var item = {
          id: i,
          total: element.count,
          sendCount: element.count,
          persianPrice: element.persianPrice,
          englishPrice: element.englishPrice,
          startFrom: 1,
          polygon: [element.coordinates],
          operator: element.operator,
        };
        this.Model.push(item);
        i++;
      });
      this.form.disable();
      if (this.Model.length > 0) this.Map().setModel(this.Model);

      // switch(this.Model)
    }
  }
  /**
   * after the view initialized the request id get and fetching data from server
   */
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    try {
      super.ngOnInit();
      this.pageVocabs = 'pages.confirmSmartSmsRequest.';
      this.fields = this.pageVocabs + 'fields.';
      this.pageConfig.showHelpBtn = false;
      this.configBaseSendSMS();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    try {
      return this.enumService
        .enumsGetEnumValues({ EnumTypeName: enumName })
        .pipe(
          takeUntil(this.onDestroy$),
          map((res) => res.data)
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  onMapLoad() {
    let id = this.smartSmsShareMem.getScheduledMessageId();
    if (id > 0) this.loadWithRequestId(id);
  }

  isShowSidePanel(event) {
    this.showSidePanel = event;
  }
}
